import ROBOTIZZ_EXT_1 from "./ROBOTIZZ_EXT_1";
export default {
  ROBOTIZZ_EXT_1,
};
